// @flow

import React, { useState } from 'react';
import { VideoPlayerAndSidebar } from '@ta/social.section-video';
import { InteractionLogger } from '@ta/tracking.interactions';

import { truncateLinkInfo } from './shared';
import styles from './DmoVideoCard.less';

const maxCaptionChar = 105;

const DmoVideoCard = ({ content }: { content: any }) => {
  const [isOpen, toggleOpen] = useState(false);
  const trackingParams = {
    contentType: 'VIDEO',
    contentId: content.id,
    sponsoredBy: content.object.userProfile.userId,
  };
  return (
    <React.Fragment>
      <div className={styles.videoContainer}>
        <InteractionLogger>
          {logInteraction => (
            <VideoPlayerAndSidebar
              preload="none"
              autoplayWhenVisible={false}
              usePoster
              isOpen={isOpen}
              onClick={() => {
                logInteraction(null, 'rightRailDestinationSpotlightClick', trackingParams);
                return !isOpen ? toggleOpen(!isOpen) : undefined;
              }}
              onClose={() => toggleOpen(false)}
              maxVideoHeight={350}
              actor={content.object.userProfile}
              deleteObject={null}
              untagObject={null}
              video={content}
            />
          )}
        </InteractionLogger>
      </div>
      <div className={styles.caption}>
        {truncateLinkInfo(content.object.caption, maxCaptionChar)}
      </div>
    </React.Fragment>
  );
};

export default DmoVideoCard;
